<template>
  <BaseCustomizeMetal componentCode="AP" />
</template>

<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalAP",
  components: {
    BaseCustomizeMetal,
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 129px;
    left: 118px;
    @include betweenTableTablePro {
      top: 90px;
      left: 68px;
    }
    @include table {
      top: 72px;
      left: 43px;
    }
    @include phone {
      top: 61px;
      left: 29px;
    }
  }
  .templeName {
    height: 28px;
    width: 223px;
    .textContainer {
      width: 223px;
    }
  }
  .godName {
    width: 263px;
    height: 53px;
    .textContainer {
      width: 263px;
    }
  }
  .gift {
    margin: 0 17px auto auto;
    width: 178px;
    height: 32px;
    .textContainer {
      width: 178px;
    }
  }
  .respect {
    position: absolute;
    bottom: 3px;
    left: 15px;
  }
}
</style>
